// extracted by mini-css-extract-plugin
export default {"titleIcon":"Sp8RF5"};